"use client";

import { useState } from "react";
import { Service } from "@/Types/responses/service";
import ServiceCard from "../../about/server/ServiceCard";
import { GRID_CLASSES } from "@/libs/grid/grid";

interface ServicesGridProps {
    results: Service[];
}

export default function ServicesGrid({ results }: ServicesGridProps) {
    const [hoveredIndex, setHoveredIndex] = useState(0);

    if (!results || results.length === 0) {
        return (
            <div className="flex w-full flex-col items-center justify-center gap-3 py-24 text-center">
                <p className="text-xl font-bold md:text-2xl">No services found</p>
                <p className="max-w-md text-base text-muted-foreground">
                    We couldn&apos;t find any services matching your criteria.
                </p>
            </div>
        );
    }

    return (
        <div className={`py-12 md:py-24 3xl:pt-20 ${GRID_CLASSES}`}>
            <div className="col-span-6 md:col-span-12">
                <div
                    className="flex w-full h-90 md:h-125 gap-4 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none -mx-6 px-6 md:mx-0 md:px-0"
                    onMouseLeave={() => setHoveredIndex(0)}
                >
                    {results.map((service, i) => (
                        <ServiceCard
                            key={service._id ?? i}
                            service={service}
                            isHovered={hoveredIndex === i}
                            onHover={() => setHoveredIndex(i)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}